import React from "react";
import "../styles/Contact.css";
import emailjs from "emailjs-com";

function Contact() {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_2ksr9zg",
        "template_bafne8c",
        e.target,
        "user_Ik2oLbE3kIB6I0SOMugrX"
      )
      .then((res) => {
        console.log(res);
        e.target.reset();
      })
      .catch((err) => {
        console.log(err);
        e.target.reset();
      });
  };

  return (
    <div className="contact">
      <div className="container">
        <div className="contact_left">
          <h1>Contact Us</h1>
          <p>
            Fill out our form and a software expert will contact you within
            24hrs.
          </p>
          <form onSubmit={sendEmail}>
            <label for="name">Your Name</label>
            <br />
            <input type="text" name="name" placeholder="John Stev" />
            <br />
            <br />
            <label for="examplePassword">Email</label>
            <br />

            <input type="email" name="user_email" placeholder="jh@gmail.com" />
            <br />
            <br />
            <label htmlFor="message">Message</label>
            <br />
            <textarea
              placeholder="Your Requirements"
              name="message"
              cols="30"
              rows="5"
            ></textarea>
            <br />

            <button type="submit" value="Send" className="contact_btn-form">
              Submit
            </button>
          </form>

          <br />

          <button className="contact_btn">
            <a className="contact_btn" href="tel:+919326300785">
              Talk With Our Expert
            </a>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Contact;
